import Vue from "vue";
import { PagesService } from "@/common/api.service";
import { FETCH_PAGE, RESET_PAGE_STATE } from "./actions.type";
import {
  FETCH_START,
  FETCH_END,
  SET_PAGE,
  RESET_STATE
} from "./mutations.type";

const initialState = {
  page: {},
  isLoading: true
};

const state = { ...initialState };

const getters = {
  isLoading(state) {
    return state.isLoading;
  },
  page(state) {
    return state.page;
  }
};

const actions = {
  async [FETCH_PAGE](context, pageSlug) {
    const data = await PagesService.get(pageSlug);
    const { result } = data.data;
    context.commit(SET_PAGE, result);
  },
  [RESET_PAGE_STATE](context) {
    context.commit(RESET_STATE);
  }
};

const mutations = {
  [FETCH_START](state) {
    state.isLoading = true;
  },
  [FETCH_END](state) {
    state.isLoading = false;
  },
  [SET_PAGE](state, page) {
    state.page = page;
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
